import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

const SubscriptionModal = ({ open, onClose, subscription }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Subscription Details</DialogTitle>
      <DialogContent>
        <div>
          <strong>Name:</strong> {subscription.name}
        </div>
        <div>
          <strong>Price:</strong> ${subscription.price}
        </div>
        <div>
          <strong>Number of Assets:</strong> {subscription.numberOfAssets}
        </div>
        <div>
          <strong>Scan Frequency:</strong> {subscription.scanFrequency}
        </div>
        <div>
          <strong>Security Posture:</strong> {subscription.securityPosture}
        </div>
        <div>
          <strong>Security Posture Report:</strong> {subscription.securityPostureReport}
        </div>
        <div>
          <strong>Support Response:</strong> {subscription.supportResponse}
        </div>
        <div>
          <strong>Add-ons:</strong>
          <ul>
            {subscription.addons.map((addon, index) => (
              <li key={index}>
                {addon.name} - ${addon.price} ({addon.description})
              </li>
            ))}
          </ul>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubscriptionModal;
